import Cache from '@panda/cache/src/common/cache';

const cache = new Cache();

const timeUtil = {
  async getSystemTime() {
    if (window.PandaNamespace.serverTimeDiff) {
      return new Date().getTime() - window.PandaNamespace.serverTimeDiff;
    }
    const time = await cache.getSystemTime({});
    return time;
  },
  /**
   * 剩余天数
   * @param startTime 开始时间（时间戳）
   * @param endTime 结束时间（时间戳）
   * @returns 天数（小于1天按1天处理）
   */
  remainDay(startTime: number, endTime: number): number {
    if (!startTime || !endTime) {
      return 0;
    }
    const remainSec = parseInt(`${(endTime - startTime) / 1000}`, 10);
    if (remainSec <= 0) {
      return 0;
    }
    const days = remainSec / 60 / 60 / 24;
    return Math.ceil(days);
  },
  /*
  *传入两个时间  upTime开始时间   downtime结束时间
  *返回值格式     X天XX时XX分XX秒
  */
  lastTime(upTime: number, downtime: number): string {
    const s = parseInt(`${(downtime - upTime) / 1000}`, 10);
    // 看传入的时间格式
    // var s = downtime-upTime;
    let days;
    let daysText;
    let hours;
    let hoursText;
    let minutes;
    let minutesText;
    let seconds;
    let secondsText;

    if (s > 86400) {
      days = s / 60 / 60 / 24;
      daysText = Math.floor(days);
      hours = s / 60 / 60 - (24 * daysText);
      hoursText = Math.floor(hours);
      minutes = s / 60 - (24 * 60 * daysText) - (60 * hoursText);
      minutesText = Math.floor(minutes);
      seconds = s - (24 * 60 * 60 * daysText) - (60 * 60 * hoursText) - (60 * minutesText);
      secondsText = Math.round(seconds);
      return `${daysText}天${hoursText}时${minutesText}分${secondsText}秒`;
    } if (s > 3600 && s <= 86400) {
      hours = s / 60 / 60;
      hoursText = Math.floor(hours);
      minutes = s / 60 - (60 * hoursText);
      minutesText = Math.floor(minutes);
      seconds = s - (60 * 60 * hoursText) - (60 * minutesText);
      secondsText = Math.round(seconds);
      return `${hoursText}时${minutesText}分${secondsText}秒`;
    } if (s > 60 && s <= 3600) {
      minutes = s / 60;
      minutesText = Math.floor(minutes);
      seconds = s - (60 * minutesText);
      secondsText = Math.round(seconds);
      return `${minutesText}分${secondsText}秒`;
    } if (s > 0 && s <= 60) {
      seconds = s;
      secondsText = Math.round(seconds);
      return `${secondsText}秒`;
    }
    return '';
  },

  /**
   * 计算传入时间距离当前时间距离：X小时，X天，X月，X年
   */
  getBeforeDate(lastTime: number, nowTime?: number): string {
    const lastDate = new Date(lastTime);
    const lastYear = lastDate.getFullYear();
    const lastMon = lastDate.getMonth();
    const nowDate = nowTime ? new Date(nowTime) : new Date();
    const year = nowDate.getFullYear();
    const mon = nowDate.getMonth();

    const s = parseInt(`${(nowDate.getTime() - lastTime) / 1000}`, 10);
    const MINUTE_TIME = 60;
    const HOUR_TIME = 60 * MINUTE_TIME;
    const DAY_TIME = 24 * HOUR_TIME;
    // 判断是否闰年
    const YEAR_TIME = ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0)
      ? 366 * DAY_TIME
      : 365 * DAY_TIME;
    if (s < MINUTE_TIME) {
      return `${s}秒`;
    }// 一分钟内
    if (s < HOUR_TIME) {
      return `${Math.floor(s / MINUTE_TIME)}分钟`;
    }// 一小时内
    if (s <= DAY_TIME) { // 一天内
      return `${Math.floor(s / HOUR_TIME)}小时`;
    } if (s <= 30 * DAY_TIME || (s <= 31 * DAY_TIME && mon === lastMon)) { // 30天内
      return `${Math.floor(s / DAY_TIME)}天`;
    } if (s <= YEAR_TIME) { // 一年内
      return `${12 * (year - lastYear) + mon - lastMon}个月`;
    }
    return `${year - lastYear}年`;
  },

  /**
   * 计算时间戳对应的8位日期
   */
  getDate8(stamp: number = new Date().getTime()): number {
    const date = new Date(stamp);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return parseInt(`${year}${month < 10 ? `0${month}` : month}${day < 10 ? `0${day}` : day}`, 10);
  },
  /**
   * 将本地时间转换为东八区时间
   * @param time 时间戳
   * @returns 东八区Date对象
   */
  getChinaDate(time: number): Date {
    const timezone = 8; // 目标时区时间，东八区
    const offset_GMT = new Date().getTimezoneOffset(); // 本地时间和格林威治的时间差，单位为分钟
    return new Date(time + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000);
  },

  /**
   * 判断选中日期是否过期
   * @param selectedDay 待判断是否过期的日期，格式： 2023-03-07
   * @param deadline
   * @returns
   */
  isDayOverdue(selectedDay: string, deadline: Date | number) {
    const deadLineDto = new Date(deadline);
    const year = deadLineDto.getFullYear();
    const month = deadLineDto.getMonth() + 1;
    const day = deadLineDto.getDate();
    const selectedDate = selectedDay.split('-').map(item => parseInt(item));
    if (selectedDate[0] < year) {
      return true;
    } else if (selectedDate[0] === year) {
      if (selectedDate[1] < month) {
        return true;
      } else if (selectedDate[1] === month) {
        return selectedDate[2] < day;
      }
    }
    return false;
  }
};

export default timeUtil;
